import { CartProvider } from "../../context/CartProvider";
import Home from "../Home/Home";

export const Record = () => {
  return (
    <CartProvider>
      <Home />
    </CartProvider>
  );
};
